import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/apiClient";
import { AdminHeader, AdminPage } from "@/components/admin/AdminUI";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const ROLES = ["super_admin", "admin", "editor", "contributor", "legal_reviewer"];

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", role: "contributor" });
  const load = () => api.get("/users").then(({ data }) => setUsers(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!f.email || !f.password) return toast.error("Email and password required");
    try { await api.post("/users", f); toast.success("User created"); setOpen(false); setF({ name: "", email: "", password: "", role: "contributor" }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const changeRole = async (u, role) => { try { await api.patch(`/users/${u.id}`, { role }); toast.success("Role updated"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } };
  const del = async (u) => { if (!window.confirm(`Delete ${u.email}?`)) return; try { await api.delete(`/users/${u.id}`); toast.success("Deleted"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } };

  return (
    <>
      <AdminHeader title="Users & Permissions" subtitle={`${users.length} users`} actions={<Button onClick={() => setOpen(true)} className="bg-npst-navy text-white" data-testid="add-user-btn">Add User</Button>} />
      <AdminPage>
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200"><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500">
              <th className="px-4 py-3">Name</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Role</th><th className="px-4 py-3 text-right">Actions</th>
            </tr></thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-b border-slate-100">
                  <td className="px-4 py-3 font-medium">{u.name}</td>
                  <td className="px-4 py-3 text-slate-500">{u.email}</td>
                  <td className="px-4 py-3">
                    <Select value={u.role} onValueChange={(v) => changeRole(u, v)}>
                      <SelectTrigger className="w-44 h-9" data-testid={`role-select-${u.email}`}><SelectValue /></SelectTrigger>
                      <SelectContent>{ROLES.map((r) => <SelectItem key={r} value={r} className="capitalize">{r.replace("_", " ")}</SelectItem>)}</SelectContent>
                    </Select>
                  </td>
                  <td className="px-4 py-3 text-right">{u.role !== "super_admin" && <button onClick={() => del(u)} className="text-red-600 text-sm hover:underline">Delete</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </AdminPage>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent><DialogHeader><DialogTitle className="font-serif text-2xl">Add User</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <Input placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="user-name" />
            <Input placeholder="Email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="user-email" />
            <Input placeholder="Temporary password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="user-password" />
            <Select value={f.role} onValueChange={(v) => setF({ ...f, role: v })}><SelectTrigger data-testid="user-role"><SelectValue /></SelectTrigger><SelectContent>{ROLES.map((r) => <SelectItem key={r} value={r} className="capitalize">{r.replace("_", " ")}</SelectItem>)}</SelectContent></Select>
            <Button onClick={create} className="w-full bg-npst-navy text-white" data-testid="user-create-btn">Create User</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
